/** Endereços das telas (item 4.5). */
export type Screen = "menu" | "criador" | "estadio" | "voo" | "partida";

export function screenFromHash(hash: string): Screen {
  if (hash.startsWith("#estadio")) return "estadio";
  if (hash.startsWith("#voo")) return "voo";
  if (hash.startsWith("#partida")) return "partida";
  if (hash.startsWith("#criar")) return "criador";
  return "menu";
}
